import React, { useState } from "react";
import { Icon } from "@design-system/components/Icon/Icon";
import { Search, Croix } from "@icons";
import "./SearchInput.scss";
import { Loader } from "@design-system/components/Loader/Loader";

export type SearchInputProps = {
    placeholder: string;
    value?: string;
    onValueChange: (value: string) => void;
    isGlobalSearch?: boolean;
    size?: "normal" | "big";
    isLoading?: boolean;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const SearchInput: React.FC<SearchInputProps> = ({
    placeholder,
    value = '',
    onValueChange,
    isGlobalSearch = false,
    size = "normal",
    isLoading = false,
    ...props
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);

    return (
        <div className={`search-input-wrapper ${isFocused ? "focused" : ""} ${isGlobalSearch ? "global" : ""} ${size}`} >
            <input
                className="search-input-field"
                type="text"
                value={currentValue}
                onChange={(e) => {
                    setCurrentValue(e.target.value);
                    onValueChange(e.target.value);
                }}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                placeholder={placeholder}
                {...props}
            />
            {!isLoading && currentValue && currentValue?.length > 0 ? 
            <Icon onClick={() => {setCurrentValue(""); onValueChange("")}} icon={<Croix />} size={18} color={isFocused ? "primary" : "grey1"} className="icon pointer" /> 
            : 
            <Icon icon={isLoading ? <Loader small /> : <Search />} size={18} color={isFocused ? "primary" : "grey1"} className="icon" />
            }
        </div>
    );
};  